import { defineComponent, onMounted, reactive } from 'vue';
import { useGeoMultiMethodsStore } from '@/store/ps-management/geo-multi-methods.store';
import { useCurrencyListStore } from '@/store/dictionary/currency-list.store';
import { useUploadImageStore } from '@/store/upload-image.store';
import { storeToRefs } from 'pinia';
import SegmentsAutocompleteMultiselect
  from '@/components/segments-autocomplete-multiselect/segments-autocomplete-multiselect.vue';
import { TagComponentTypes } from '@/models/app-common.model';

export default defineComponent({
  name: 'GeoMultiMethodMainSettings',
  components: {
    SegmentsAutocompleteMultiselect,
  },
  props: {
    isSaveActionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['saveAction'],
  setup(_props, { emit }) {
    const mainSettingsFormRules = reactive({
      currency: { required: true, message: 'Please select currency', trigger: 'blur' },
      publicName: { required: true, message: 'Please enter method public name', trigger: 'blur' },
      segmentList: { required: false, message: 'Please select included segments', trigger: 'blur' },
      excludedSegmentList: { required: false, message: 'Please select excluded segments', trigger: 'blur' },
      imageId: { required: true, message: 'Please upload image', trigger: 'blur' },
    });

    const geoMultiMethodsStore = useGeoMultiMethodsStore();
    const { geoMultiMethod, geoMultiMethodMainSettingsFormRef, isUnsavedChanges } = storeToRefs(geoMultiMethodsStore);
    const { setFormChanged } = geoMultiMethodsStore;

    const currencyListStore = useCurrencyListStore();
    const { currencyList, isCurrencyListLoading } = storeToRefs(currencyListStore);
    const { getCurrencyList } = currencyListStore;

    const uploadImageStore = useUploadImageStore();
    const { uploadFile } = uploadImageStore;
    const { isImageUploading } = storeToRefs(uploadImageStore);

    const saveGeoMultiMethodMainSettings = () => {
      emit('saveAction');
    };

    onMounted(() => {
      getCurrencyList();
    });

    const clearImage = () => {
      geoMultiMethod.value.imageId = '';
      geoMultiMethod.value.filePath = '';
    };

    const uploadImage = ({ file }: { file: File }) => {
      uploadFile(file)
        .then((response) => {
          if (!response) {
            throw new Error('Error uploading image');
          }

          geoMultiMethod.value.imageId = response.uploadedImageFileId;
          geoMultiMethod.value.filePath = response.uploadedImageFilePath;
        });
    };

    return {
      geoMultiMethod,
      currencyList,
      isCurrencyListLoading,
      saveGeoMultiMethodMainSettings,
      clearImage,
      uploadImage,
      isImageUploading,
      geoMultiMethodMainSettingsFormRef,
      setFormChanged,
      mainSettingsFormRules,
      isUnsavedChanges,
      TagComponentTypes,
    };
  },
});
